import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class MissingStatusTransitionRuleError extends CodedError {
  static get errorName() {
    return errorCodes.missingStatusTransitionRuleError.code;
  }

  constructor(message: string = errorCodes.missingStatusTransitionRuleError.message) {
    super(message);
    this.code = errorCodes.missingStatusTransitionRuleError.code;
    this.message = `${message} ${errorCodes.missingStatusTransitionRuleError.code}`;
    this.name = errorCodes.missingStatusTransitionRuleError.name;
  }
}
